export default __webpack_public_path__ + "e5bec074e128202b042cb1384782d9bc.png";